import { useState, useRef } from 'react';
import PhotoPickerModal from '../PhotoPickerModal';
import { compressImageFile } from '../../utils/imageUtils';

export default function AddGarageModal({ onAdd, onClose }) {
  const [name, setName] = useState('');
  const [photo, setPhoto] = useState(null);
  const [showPhotoPicker, setShowPhotoPicker] = useState(false);
  const fileRef = useRef(null);

  function handlePhoto(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    compressImageFile(file, 800, 0.8).then((dataUrl) => setPhoto(dataUrl)).catch(() => {});
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim()) return;
    onAdd(name.trim(), photo);
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 200,
        padding: 20,
      }}
      onClick={onClose}
    >
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
        style={{
          background: 'var(--bg-card)',
          borderRadius: 'var(--radius-md)',
          padding: 24,
          width: '100%',
          maxWidth: 360,
          border: '1px solid var(--border)',
        }}
      >
        <h2 style={{ fontSize: '1.125rem', fontWeight: 700, marginBottom: 20 }}>
          New Garage
        </h2>

        {/* Name */}
        <div className="form-group">
          <label className="form-label">Garage Name</label>
          <input
            className="form-input"
            type="text"
            placeholder="e.g. Home Garage"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>

        {/* Photo (optional) */}
        <div className="form-group">
          <label className="form-label">Photo (optional)</label>
          {photo ? (
            <div style={{ position: 'relative', marginBottom: 8 }}>
              <img
                src={photo}
                alt="Garage"
                style={{
                  width: '100%',
                  height: 120,
                  objectFit: 'cover',
                  borderRadius: 'var(--radius-sm)',
                }}
              />
              <button
                type="button"
                onClick={() => setPhoto(null)}
                style={{
                  position: 'absolute',
                  top: 6,
                  right: 6,
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  background: 'rgba(0,0,0,0.6)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.875rem',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                x
              </button>
            </div>
          ) : (
            <>
              <input
                ref={fileRef}
                type="file"
                accept="image/*"
                onChange={handlePhoto}
                style={{ display: 'none' }}
              />
              <button
                type="button"
                onClick={() => setShowPhotoPicker(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8,
                  padding: '14px 16px',
                  background: 'var(--bg-input)',
                  border: '1.5px dashed var(--border)',
                  borderRadius: 'var(--radius-sm)',
                  color: 'var(--text-muted)',
                  fontSize: '0.875rem',
                  cursor: 'pointer',
                  width: '100%',
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
                Add photo
              </button>
            </>
          )}
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            style={{ flex: 1 }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!name.trim()}
            style={{ flex: 1 }}
          >
            Create
          </button>
        </div>
      </form>

      <PhotoPickerModal
        show={showPhotoPicker}
        onClose={() => setShowPhotoPicker(false)}
        onSelect={(source) => {
          setShowPhotoPicker(false);
          fileRef.current.removeAttribute('capture');
          fileRef.current.click();
        }}
      />
    </div>
  );
}
